"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
class PortalInsuranceConfig {
    constructor(underwriter) {
        this.underwriter = underwriter;
    }
    static fromObj(data) {
        return new PortalInsuranceConfig(__1.Underwriter.fromObj(data.underwriter));
    }
}
exports.default = PortalInsuranceConfig;
//# sourceMappingURL=portalInsuranceConfig.class.js.map